/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

// We must temporarily lose the Window type because Cypress appends to the Window object and isn't standard.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IS_TEST_ENVIRONMENT = window.hasOwnProperty('Cypress') && typeof (window as any).Cypress === 'object';
